import { Button, Carousel, Tooltip } from 'flowbite-react';
import { useEffect, useState } from 'react';
import Loader from '../Common/Loader';
import blankImage from '../../Assets/NoPhoto.jpg';
import { Link, useParams } from 'react-router-dom';
import UserApi from '../../Api/UserApi';
import { useAppSelector } from '../../Reducers/store';
import { HiPencilAlt } from 'react-icons/hi';
import { Manufacturer } from '../../Models/Manufacturer';
import ManufacturerApi from '../../Api/ManufacturerApi';
import EquipmentList from '../Equipment/EquipmentList';
import { EquipmentTypeEnums } from '../../Models/EquipmentTypeEnums';
import { FileTypeEnums } from '../../Models/FileType';
import DOMPurify from 'isomorphic-dompurify';

export default function ManufacturerProfile() {
  const { userModel } = useAppSelector((state) => state.user);
  const { id } = useParams();
  const [manufacturerData, setManufacturerData] =
    useState<Manufacturer | null>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const getManufacturer = () => {
    if (id) {
      setIsLoading(true);
      ManufacturerApi.getManufacturer(id)
        .then((res) => {
          setManufacturerData(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setIsLoading(false);
        });
    } else {
      setManufacturerData(null);
    }
  };

  useEffect(() => {
    getManufacturer();
  }, [id]);

  function checkAccess() {
    if (manufacturerData && userModel && id) {
      return true;
      // if (userModel.userLevelId === UserLevelNames.SuperAdmin) {
      //   return true;
      // } else if (
      //   userModel.memberId === manufacturerData.memberId &&
      //   userModel.id === Number(id)
      // ) {
      //   return true;
      // } else if (
      //   userModel.memberId === manufacturerData.memberId &&
      //   userModel.userLevelId === UserLevelNames.MemberAdmin
      // ) {
      //   return true;
      // } else {
      //   return false;
      // }
    }
    return false;
  }

  return (
    <div className='w-full'>
      <div className='w-full p-4'>
        <div className='mx-1 flex items-end'>
          <div className='flex flex-1'>
            <h1 className='text-gray-900 font-bold text-4xl'>
              Manufacturer Information
            </h1>
          </div>
          {checkAccess() && (
            <div className='right-2'>
              <Link to={`/edit/manufacturer/${manufacturerData?.id}`}>
                <Tooltip content='Edit'>
                  <Button className='buttonMain'>
                    <HiPencilAlt size={20} />
                  </Button>
                </Tooltip>
              </Link>
            </div>
          )}
        </div>
      </div>

      <div>
        <div className='container mx-auto p-2'>
          <div className='md:flex no-wrap md:-mx-2 '>
            <div className='w-full md:w-3/12 md:mx-2'>
              <div className='h-56 sm:h-64 xl:h-80 2xl:h-96 overflow-hidden rounded-md'>
                {manufacturerData?.files?.filter(
                  (x) => x.fileTypeId === FileTypeEnums.Photo
                ).length === 0 && <img src={blankImage} alt={'blank-image'} />}
                {manufacturerData?.files &&
                  manufacturerData?.files?.filter(
                    (x) => x.fileTypeId === FileTypeEnums.Photo
                  ).length > 0 && (
                    <Carousel slide={false} className='border-2 rounded-lg'>
                      {manufacturerData?.files
                        .sort(
                          (a, b) => Number(b.isPrimary) - Number(a.isPrimary)
                        )
                        .map((data) => (
                          <img
                            key={data.id}
                            src={data.fileUrl!}
                            alt={manufacturerData.name + '-image'}
                          />
                        ))}
                    </Carousel>
                  )}
              </div>
            </div>
            <div className='w-full md:w-10/12 mx-2'>
              <div className='bg-white p-3'>
                <div className='flex items-center space-x-2 font-bold text-gray-500 leading-8 py-2'>
                  <span className='tracking-wide uppercase text-3xl'>
                    {manufacturerData?.name}
                  </span>
                </div>
                <hr className='bg-gray-300 h-[5px]'></hr>
                <div className='text-gray-500'>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Email:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {manufacturerData?.email}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Phone:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {manufacturerData?.phone &&
                        '(' +
                          manufacturerData?.phone
                            .replace(/[^0-9]+/g, '')
                            .slice(0, 3) +
                          ') ' +
                          manufacturerData?.phone
                            .replace(/[^0-9]+/g, '')
                            .slice(3, 6) +
                          '-' +
                          manufacturerData?.phone
                            .replace(/[^0-9]+/g, '')
                            .slice(6)}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Address:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {manufacturerData?.city}, {manufacturerData?.state?.name}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Rimss Id:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {manufacturerData?.rimssId}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Website:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      {manufacturerData?.website}
                    </div>
                  </div>
                  <hr className='bg-gray-300 h-[2px]'></hr>
                  <div className='grid grid-cols-[40%_60%] md:grid-cols-[25%_75%] xl:grid-cols-[14%_86%] py-2 text-xl'>
                    <div className='flex'>
                      <div className='font-bold'>Description:</div>
                    </div>
                    <div className='pl-1 text-black'>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(
                            manufacturerData?.description ?? ''
                          ),
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className='bg-white p-3'>
                {id && (
                  <EquipmentList
                    manufacturerId={parseInt(id)}
                    equipmentType={EquipmentTypeEnums.Equipment}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
